import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { EndpointPathNames } from "@/shared/config/endpoint-path";
import { useSignUp } from "@/features/user/hooks/use-sign-up";
import { useAgreeTerms } from "@/features/legal/hooks/use-agree-terms";
import { LoginHeader } from "@/shared/components/header/login-header";
import { Footer } from "@/shared/components/footer/footer";
import { MailAddressForm } from "@/shared/components/text-box/mail-address-form";
import { AgreeTermsCheckbox } from "@/features/legal/components/agree-terms-check-box";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";
import { AuthenticationType } from "@/shared/config/globals";
import { Checkbox } from "@/shared/components/check-box/check-box";
import { FAQ_URL } from "@/shared/config/constants";

export const FirstAuth = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const {
    email,
    newEmail,
    emailError,
    isActiveSendMailButton,
    setIsActiveSendMailButton,
    setNewEmail,
    onChangeNewMailAddress,
    onClickSendMail,
  } = useSignUp();

    const {
      onTapAgreement,
      checkedAgreement,
      setCheckedAgreement,
    } = useAgreeTerms();

  const [isChangeMailChecked, setIsChangeMailChecked] = useState(false);
  const [legal, setLegal] = useState(false);

  useEffect(() => {
    const reloginCheck = () => {
      const queryParams = new URLSearchParams(location.search);
      const legal = queryParams.get("legal");
      if (legal === "1") {
        setLegal(true);
      } else {
        setCheckedAgreement(true);
      }
    };
    reloginCheck();
  }, [location.search]);

  const onToggleChangeMail = () => {
    setIsChangeMailChecked((prev) => {
      const next = !prev;
      if (next) {
        setNewEmail("");
      } else {
        setNewEmail(email);
      }
      return next;
    });
  };

  // メールアドレスフォームに付与するID
  const mailAddressFormId = "mail_address_form_id";
  // メールアドレス（確認）フォームに付与するID
  //const mailAddressConfirmFormId = "mail_address_confirm_form_id";

  // メールアドレス入力情報が更新された場合のコールバック関数定義
  const changeSendMailButtonState = () => {
    if (isChangeMailChecked) {
      setIsActiveSendMailButton(newEmail !== "" && checkedAgreement);
    } else {
      setIsActiveSendMailButton(email !== "" && checkedAgreement);
    }
  };

  // ログイン画面遷移
  const pushLoginView = () => {
    navigate(EndpointPathNames.LOGIN);
  };

  useEffect(() => {
    changeSendMailButtonState();
  }, [newEmail, email, isChangeMailChecked, checkedAgreement]);

  const cancelButtonId = "cancel_button_id";

  return (
    <>
      <LoginHeader content="メールアドレス認証" />
      <main>
        <section id="signUp" className="auth-completed">
          <nav className="step">
            <ol>
              <li className="active">認証メールを送信</li>
              <li className="">認証完了</li>
            </ol>
          </nav>
          <p className="first_auth_text">
            認証を行うため、受信ができるメールアドレスを入力してください。<br />
            現在のメールアドレスでよければ、そのまま「メールを送信」を押してください。<br />
            変更する場合のみ、「メールアドレスを変更する」にチェックを入れて、新しいメールアドレスを入力してください。<br />
          </p>
          <ul className="form first_auth_form">
            <li>
              <MailAddressForm
                id={mailAddressFormId}
                initialValue={email}
                isReadOnly={true}
                title="現在のメールアドレス"
              />
            </li>
            <li>
              <Checkbox
                label="メールアドレスを変更する"
                id="change-mail-address-checkbox"
                checked={isChangeMailChecked}
                handleChange={onToggleChangeMail}
              />
              {isChangeMailChecked && (
                <MailAddressForm
                  title="新しいメールアドレス"
                  onChange={onChangeNewMailAddress}
                  errorMessage={emailError}
                  id={mailAddressFormId}
                  placeholder="メールアドレスを入力"
                />
              )}
            </li>
            {legal && (
            <li>
              <AgreeTermsCheckbox
                checked={checkedAgreement}
                onTapAgreement={onTapAgreement}
              />
            </li>
            )}
          </ul>
          {/* 正式なURLが用意できていないため、コメントアウト */}
          {/* <p className="first_auth_text">
            <Link to={FAQ_URL} target="_blank" rel="noopener noreferrer">認証について詳しく見る(遷移先は未実装)</Link>
          </p> */}
          <nav className="btns">
            <span style={{ marginRight: "0.3rem"}}>
              <BaseRoundButton
                className="btn-base"
                id={cancelButtonId}
                buttonText="キャンセル"
                onClick={pushLoginView}
                isActive={true}
              />
            </span>
            <BaseRoundButton
              className="nav-main"
              buttonText="メールを送信"
              onClick={() => onClickSendMail(AuthenticationType.FirstAuth, isChangeMailChecked)}
              isActive={isActiveSendMailButton}
            />
          </nav>
        </section>
      </main>
      <Footer />
    </>
  );
};